import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"phone\">\r\n  <path d=\"M760 0H264c-39.8 0-72 32.2-72 72v880c0 39.8 32.2 72 72 72h496c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72zM542 960h-60c-19.9 0-34-14.3-34-32s14.1-32 34-32h60c19.9 0 34 14.3 34 32s-14.1 32-34 32z m218-129H264V127h496v704z\" fill=\"currentColor\" p-id=\"5989\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol